


















import { Component, Mixins, Watch } from 'vue-property-decorator'
import { LIBRARY_LOADING_STATE } from '../../store/modules/library'
import { ILibraryMetadata } from '@/interfaces/library'
import { checkAndFetchlibrary } from '@/helpers/library'
import { LibraryMixin } from '@/mixins'

@Component({
  components: {
    Sidebar: require('@/components/Sidebar').default,
    Banner: require('@/components/Banner').default,
    FullscreenLoader: require('@/components/FullscreenLoader').default
  }
})
export default class Private extends Mixins(LibraryMixin) {
  allowLibraryWatch: boolean = true

  get loading(): boolean {
    return (
      this.$store.state.library.loadingState === LIBRARY_LOADING_STATE.LoadingFromCache ||
      this.$store.state.library.loadingState === LIBRARY_LOADING_STATE.Fetching
    )
  }

  get loaderLabel(): string {
    return this.$store.state.auth.isDemoUser ? 'Downloading demo library...' : 'Syncing library...'
  }

  get libraryMetadata(): ILibraryMetadata {
    return this.$store.state.library.metadata
  }

  get bannerMessage(): string {
    if (this.$store.state.auth.isDemoUser) return `You are in demo mode. You can look around and play with everything, but you can't use your own library`
    if (this.$store.state.firebase.remoteConfig.emergency_banner_message) return this.$store.state.firebase.remoteConfig.emergency_banner_message

    return ''
  }

  get bannerVisibile(): boolean {
    if (this.$store.state.auth.isDemoUser) return true
    if (this.$store.state.firebase.remoteConfig.emergency_banner_message) return true

    return false
  }

  get bannerType(): 'has-background-warning' {
    return 'has-background-warning'
  }

  async onWindowFocus() {
    if (!this.$store.state.popupOpen) {
      await checkAndFetchlibrary()
    }
  }

  async created() {
    this.$store.commit('library/loadLibrary')

    // Set window width to initial, this forces desktop mode on mobile screens since the rekordcloud private routes arent mobile friendly
    // const viewportMetaTag = document.querySelector('meta[name="viewport"]')

    // if (viewportMetaTag) {
    //   // viewportMetaTag.setAttribute('content', 'width=initial')
    // }

    if (window.innerWidth <= 768) {
      window.alert(`The rekordcloud tools are designed to be used on a larger screen.\nYou can still use it but your experience may not be optimal.`)
    }

    window.addEventListener('focus', this.onWindowFocus)

    setTimeout(() => {
      let message = `Rekordcloud 2.0 called <a class="link underline" href="https://www.lexicondj.com">Lexicon</a> is now available. It can do anything Rekordcloud can do and more. It is faster and easier to use.`

      if (this.$store.state.subscription.active) {
        message += `<br>
      <br>
      Lexicon is included in your Rekordcloud subscription so you can get started right away.`
      }

      message += `<br>
      <br>
      <a class="link underline" href="https://www.lexicondj.com">Check out Lexicon</a>`

      this.$buefy.dialog.alert({
        title: 'Lexicon',
        message,
        type: 'is-primary',
        confirmText: 'Close'
      })
    }, 500)
  }

  destroyed() {
    window.removeEventListener('focus', this.onWindowFocus)
  }

  @Watch('library')
  async fetchLibrary() {
    if (!this.$store.state.auth.isLoggedIn || !this.allowLibraryWatch) return

    if (!this.library) {
      this.allowLibraryWatch = false

      try {
        await checkAndFetchlibrary()
      } finally {
        setTimeout(() => {
          this.allowLibraryWatch = true
        }, 1000)
      }
    }
  }
}
